/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_DeletingInputs */



/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Common_DeletingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_deleting = /** @type {((inputs?: Common_DeletingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DeletingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suppression...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluindo...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminazione...")
	return /** @type {LocalizedString} */ ("Deleting...")
});